"use strict";var ddSdk_1=require("./lib/ddSdk"),otherApi=require("./lib/otherApi"),core=Object.assign({},otherApi,ddSdk_1.ddSdk.getExportSdk());module.exports=core;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_dingtalk-jsapi@2.13.50@dingtalk-jsapi/core.js
// module id = 3gBz
// module chunks = 0